// extracted by mini-css-extract-plugin
export default {"rounded_btn":"RoundedButton_rounded_btn__vmqMM","copied":"RoundedButton_copied__ZoiAe"};